module.exports = __webpack_public_path__ + "assets/img/year-title-bg1.74d5aae3.png";